import { post } from '@classic/Foundation/Services/ApiService'

export interface SkyVideoEntitlementDto {
  IsEntitled: boolean
  SecureUri: string
  ReasonText?: string
}

export function getSkyVisionSecureUrl(uri: string) {
  return post<SkyVideoEntitlementDto>({
    url: '/api/videoentitlement/getskyvisionsecureurl',
    body: { uri },
  })
}
